import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { UMPSection } from './components/UMPSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { ProductSection } from './components/ProductSection';
import { IsForYouSection } from './components/IsForYouSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { VisionSection } from './components/VisionSection';
import { FAQSection } from './components/FAQSection';
import { PricingSection } from './components/PricingSection';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { RecentPurchaseNotification } from './components/RecentPurchaseNotification';
export function App() {
  return <div className="min-h-screen bg-warm-cream font-sans text-warm-brown antialiased selection:bg-rose-200 selection:text-rose-900" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <RecentPurchaseNotification data-id="element-2" />

      <Header data-id="element-3" />

      <main data-id="element-4">
        <HeroSection data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <UMPSection data-id="element-7" />
        <HowItWorksSection data-id="element-8" />
        <ProductSection data-id="element-9" />
        <IsForYouSection data-id="element-10" />
        <TestimonialsSection data-id="element-11" />
        <VisionSection data-id="element-12" />
        <FAQSection data-id="element-13" />
        <PricingSection data-id="element-14" />
      </main>

      <Footer data-id="element-15" />
    </div>;
}